import { Map } from 'immutable'
import _get from 'lodash/get'
import * as actions from './actions'
import { STATUS_FILTER_UNRESOLVED } from '..'

export const initialState = Map({
  filter: STATUS_FILTER_UNRESOLVED,
})

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case actions.SET_USER_MODERATION_REPORT_GROUPS:
      return state.set('data', _get(payload, 'data', Map()))
    case actions.SET_STATUS_FILTER:
      return state.set('filter', _get(payload, 'filter', Map()))
    default:
      return state
  }
}
